var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.priceModel.displayFeaturesDescription),function(desc,descIndex){return _c('div',{key:_vm.priceModel.id + '_desc_' + descIndex},[_c('div',{domProps:{"innerHTML":_vm._s(desc)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }